import { useState, useRef, useEffect } from "react";
import axios from "axios";

import { getCaseId, getClientId, getToken } from "../../Utils/helper";
import api, { api_without_cancellation } from "../../api/api";
import { useDocumentModal } from "../common/CustomModal/CustomModalContext";
import CourtFormModalSideBar from "../CourtForm/CourtFormSideBar/CourtFormModalSideBar";

import WPCourtFormBase from "./WPCourtFormBase";
import SendEmailPopUp from "./SendEmailPopUp";

function WPCourtForm({
  docId,
  updatedDocId,
  courtFormId,
  dispatch,
  state,
  fetchEditDocs,
  type,
  litigationId,
  showRightSidebar,
}) {
  const origin = process.env.REACT_APP_BACKEND_URL;

  const container = useRef(null);

  const [docName, setDocName] = useState(null);
  const [docData, setDoctData] = useState(null);
  const [emailPopUp, setEmailPopUp] = useState(false);

  const [_saveLoading, setSaveLoading] = useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [clientData, setClientData] = useState(null);

  // New
  const currentCaseId = getCaseId();
  const token = getToken();
  const [slotsData, setSlotsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pages, setPages] = useState([]);
  const { documentData, refetchDocumentData } = useDocumentModal();

  useEffect(() => {
    const fetchDataFirstTime = async () => {
      try {
        const response = await axios.get(
          `${origin}/api/general/get-attach-menu/?case_id=${Object.keys(docData).length ? docData?.for_case?.id : currentCaseId}&client_id=${Object.keys(docData).length ? docData?.for_client?.id : getClientId()}`,
          {
            // params: {
            //   page_id: "",
            //   case_id: Object.keys(docData).length ? docData?.for_case?.id : currentCaseId,
            //   all_docs: "True",
            //   client_id: Object.keys(docData).length ? docData?.for_client?.id : getClientId(),
            // },
            headers: {
              Authorization: token,
            },
          }
        );
        if (response.status === 200) {
          setSlotsData(response.data.data);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (token) {
      fetchDataFirstTime();
    }
  }, [currentCaseId, docData, token]);

  const fetchPageDetails = async (caseId) => {
    try {
      const response = await axios.get(`${origin}/api/pages/${caseId}/`, {
        headers: {
          Authorization: token,
        },
      });
      setPages(response.data);
    } catch (error) {
      console.error("Error occurred while fetching pages", error);
    }
  };

  useEffect(() => {
    setPages([]);
    if (docData?.for_case?.id) {
      fetchPageDetails(docData?.for_case?.id);
    }
  }, [docData]);

  const abortControllerRef = useRef(null);
  const refetchSlotsData = async () => {
    // Abort the previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new controller
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const response = await axios.get(
        `${origin}/api/general/get-attach-menu/?case_id=${Object.keys(docData).length ? docData?.for_case?.id : currentCaseId}&client_id=${Object.keys(docData).length ? docData?.for_client?.id : getClientId()}`,
        {
          // params: {
          //   page_id: "",
          //   case_id: docData?.for_case?.id || "",
          //   all_docs: "True",
          //   client_id: docData?.for_client?.id || "",
          // },
          headers: {
            Authorization: token,
          },
          signal: controller.signal,
        }
      );

      if (response.status === 200) {
        setSlotsData(response.data.data);
      }
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Previous API call aborted.");
      } else {
        console.error("API error:", error);
      }
    }
  };

  // New End

  const fetchClientPage = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/client-page/client/${getClientId()}/case/${getCaseId()}/`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status === 200) {
        setClientData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch client data:", error);
    }
  };

  useEffect(() => {
    fetchClientPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteEditDoc = async () => {
    try {
      const formData = new FormData();
      formData.append("doc_id", docId);

      const response = await api_without_cancellation.post(
        `${origin}/api/delete-edit-doc/`,
        formData
      );
      if (response.status === 200) {
        if (response.data.success) {
          fetchEditDocs();
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  // const saveDraft = async () => {
  //   try {
  //     const content =
  //       await container.current?.documentEditor.saveAsBlob("Docx");
  //   } catch (error) {
  //     console.error("Error saving document:", error);
  //   }

  //   dispatch({
  //     type: "SHOW_MODAL",
  //     payload: "Doc Updated successfully!",
  //   });
  // };

  const attachPdfToCaseFile = async () => {
    setSaveLoading(true);
    const content = await container.current?.documentEditor.saveAsBlob("Docx");
    const renamedFile = new File([content], `${docName}.docx`, {
      type: content.type,
    });

    const formData = new FormData();
    formData.append("file", renamedFile);
    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("panel_id", litigationId);

    try {
      const response = await api.post(
        `${origin}/api/documents/pdf-to-casefile-litigation/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        const { data, filename } = response.data;
        const pdfBlob = new Blob([Uint8Array.from(atob(data), (c) => c.charCodeAt(0))], {
          type: "application/pdf",
        });
        const url = URL.createObjectURL(pdfBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        await deleteEditDoc();
      }
    } catch (error) {
      console.error("Error printing document:", error);
    } finally {
      setSaveLoading(false);
    }
  };

  const controls = (
    <>
      {docData && (
        <CourtFormModalSideBar
          docData={docData}
          documentData={documentData}
          pages={pages}
          slotsData={slotsData}
          onRefetchSlotsData={refetchSlotsData}
          loading={loading}
          setSlotsData={setSlotsData}
          refetchDocumentData={refetchDocumentData}
          litigationId={litigationId}
          docId={docId}
          fetchEditDocs={fetchEditDocs}
          dispatch={dispatch}
          type={type}
          container={container}
          docName={docName}
        />
      )}
    </>
  );

  const handleCloseEmailPopUp = () => {
    setEmailPopUp(false);
  };

  return (
    <>
      <WPCourtFormBase
        docId={docId}
        updatedDocId={updatedDocId}
        courtFormId={courtFormId}
        setDocName={setDocName}
        setDoctData={setDoctData}
        state={state}
        dispatch={dispatch}
        container={container}
        controls={controls}
        type="CourtForm"
        showRightSidebar={showRightSidebar}
      />

      <SendEmailPopUp
        emailPopUp={emailPopUp}
        handleCloseEmailPopUp={handleCloseEmailPopUp}
        attachPdfToCaseFile={attachPdfToCaseFile}
        container={container}
        docName={docName}
      />
    </>
  );
}

export default WPCourtForm;
